import Extend from 'flarum/common/extenders';
import Modal from './models/Modal';
export default [new Extend.Store() //
.add('modals', Modal)];